// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type GetCurrentClientLocationMutationVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentClientLocationMutation = { geolocationGetCurrentClientLocation: { country: { id: string, countryCode: string | undefined, countryName: string | undefined, cityName: string | undefined } | undefined, errors: Array<{ message: string | undefined, code: number | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const GetCurrentClientLocationMutationDocument = gql`
    mutation GetCurrentClientLocationMutation {
  geolocationGetCurrentClientLocation(input: {  }) {
    country {
      id
      countryCode
      countryName
      cityName
    }
    errors {
      message
      code
      params {
        name
        value
      }
    }
  }
}
    `;